import useBirlExercisesCollectionQuery from 'generated/api/birl/exercises/useBirlExerciseCollectionQuery'
import LoadingScreen from 'app/components/LoadingScreen'

export default () => {
  const { isPending, data: { birlExercises } = {} } =
    useBirlExercisesCollectionQuery()

  if (isPending) return <LoadingScreen />

  return (
    <div className="fcol flex-1">
      <h1> Exercises </h1>
      <div className="flex-1 frow">
        <div className="flex-1 fcol">
          <div>
            {birlExercises.map((birlExercise) => {
              return <div key={birlExercise.id}> {birlExercise.name} </div>
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
